export default "__VITE_ASSET__xV6lYsbc__"